<div class="main-container custom-scrollbar ">

  <!-- measures point-->
  <ng-container *ngIf="(hasInfo); else noPoints">
    <!-- indicators -->
<!---
    <section class="indicators d-flex flex-column mb-16">
      <h4 class="text-primary-1-dark">{{ currentPoint?.pointMeasurementName || 'Todos' }}</h4>
      <div class="chart-container d-flex fd-row ">

        <div class="outlined-indicator speed-chart pl-16">
          <sit-speedometer [properties]="avgSpeedProps"></sit-speedometer>
        </div>

        <div class="outlined-indicator flow-chart">
          <sit-icon [icon]="Icon.flows" [sizeClass]="'icon-size-64'" alt="automóvil icono indicador flujo"></sit-icon>
          <div class="d-flex fd-col .align-items-flex-start">
            <label class="text-weight-600 text-size-22 text-md-size-14">{{
              carsFlowIndicator?.toLocaleString() ?? 'Sin información'
              }}</label>
            <label class="text-md-size-14">Flujo total</label>
          </div>
        </div>
      </div>
    </section>

  --->
    <!-- Count header -->
    <section class="count mt-24 text-primary-1-dark mb-16">
      <h4>Conteo</h4>
    </section>

    <!-- Aggregated Indicators Row -->
    <div class="d-flex fd-row justify-space-between full-height gap-16 f-wrap indicators-row mb-16">

      <!-- Vehicles -->
      <div class="indicator-box" matTooltip="Vehículos" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="indicator-content">
          <sit-icon [icon]="Icon.vehicle_blue" [sizeClass]="'icon-size-48'"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ vehicleCount }}</span>
          </div>
        </div>
      </div>

      <!-- Motorcycles -->
      <div class="indicator-box" matTooltip="Motocicletas" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="indicator-content">
          <sit-icon [icon]="Icon.motorcycle_blue" [sizeClass]="'icon-size-48'"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ motorcycleCount }}</span>
          </div>
        </div>
      </div>

      <!-- Pedestrians -->
      <div class="indicator-box" matTooltip="Personas" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="indicator-content">
          <sit-icon [icon]="Icon.pedestrian_blue" [sizeClass]="'icon-size-48'"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ pedestrianCount }}</span>
          </div>
        </div>
      </div>

    </div>

    <!--  image direction-->
    <section class="img-direction mb-16">
      <h4 class="text-primary-1-dark mb-8">Ubicación puntos de medida</h4>
      <div class="container-img" *ngIf="imageModal;else aa">
        <img [src]="transform(imageModal.image)" alt="" class="modal-image"
          (click)="openImageModal(transform(imageModal.image))">
      </div>
      <ng-template #aa>
        <div class="container-img">
          <img src="assets/img/location-capacity.png" alt="Ubicación puntos de medida" class="modal-image">
        </div>
      </ng-template>
    </section>
  </ng-container>

  <ng-template #noPoints>
    <div class="no-points">
      <h4 class="text-primary-1-dark">{{
        errorMessage ? 'No hay puntos de medida' : 'Cargando información del sensor...'
        }}</h4>
      <p class="text-color-white">{{errorMessage}}</p>
    </div>
  </ng-template>
  <!--  <div>-->
  <!--    <mat-button-toggle-group class="d-flex fd-row" (change)="optionTypeSelected($event)" [(value)]="defaultOption">-->
  <!--      <ng-container *ngFor="let option of typeOptions">-->
  <!--        <mat-button-toggle class="full-width text-weight-600 text-size-16 montserrat-font" [value]="option">{{-->
  <!--            option-->
  <!--          }}-->
  <!--        </mat-button-toggle>-->
  <!--      </ng-container>-->
  <!--    </mat-button-toggle-group>-->
  <!--  </div>-->

  <!--  <div class="chart-line-container d-flex fd-row full-width">-->
  <!--    &lt;!&ndash; <label>Velocidad Promedio Carros Últimas 8 Horas</label> &ndash;&gt;-->

  <!--    <sit-chart-line [properties]="graphicDataGraphicList" [colorScale]="graphicColorScale" class="full-width">-->
  <!--    </sit-chart-line>-->
  <!--  </div>-->
</div>